
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "width": "16px",
    "height": "16px",
    "viewBox": "0 0 16 16",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "定位方向2"
        }
      ]
    },
    {
      "tag": "defs",
      "children": [
        {
          "tag": "filter",
          "attrsMap": {
            "id": "filter-1"
          },
          "children": [
            {
              "tag": "feColorMatrix",
              "attrsMap": {
                "in": "SourceGraphic",
                "type": "matrix",
                "values": "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0.850000 0"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "页面-1",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "监控页-单车单摄像头",
            "transform": "translate(-1129.000000, -544.000000)"
          },
          "children": [
            {
              "tag": "g",
              "attrsMap": {
                "id": "定位方向2",
                "transform": "translate(952.000000, 527.000000)",
                "filter": "url(#filter-1)"
              },
              "children": [
                {
                  "tag": "g",
                  "attrsMap": {
                    "transform": "translate(177.000000, 17.000000)"
                  },
                  "children": [
                    {
                      "tag": "rect",
                      "attrsMap": {
                        "id": "矩形",
                        "fill": "#000000",
                        "fill-rule": "nonzero",
                        "opacity": "0",
                        "x": "0",
                        "y": "0",
                        "width": "16",
                        "height": "16"
                      }
                    },
                    {
                      "tag": "path",
                      "attrsMap": {
                        "d": "M7.38296875,8.09859375 L11.8739062,3.60765625 L3.7084375,6.32953125 L7.38296875,8.09859375 Z M1.50359375,5.713125 L12.9279687,1.905 C13.1965625,1.81546875 13.4870312,1.960625 13.5765625,2.22921875 C13.6117191,2.33443252 13.6117191,2.44822373 13.5765625,2.5534375 L9.7684375,13.9778125 C9.67890625,14.2464062 9.3884375,14.3917187 9.11984375,14.3020312 C8.98834528,14.2581864 8.88018741,14.1629917 8.82,14.038125 L6.4225,9.05890625 L1.44328125,6.6615625 C1.188125,6.53875 1.0809375,6.2321875 1.20375,5.97703125 C1.26388948,5.85212819 1.3720653,5.75691768 1.50359375,5.713125 Z",
                        "id": "形状",
                        "fill": "#2E3133",
                        "fill-rule": "nonzero"
                      }
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
})
    }
  